<div class="mat-dialog-draggable-main-content mat-dialog-signature-process">
    <div class="mat-dialog-draggable-header">
      <h2 mat-dialog-title mat-dialog-draggable-title>{{'title.resend_contract' | translate}}  {{ data.document.name }}
        <button type="button" class="close" aria-label="Close" (click)="onNoClick()" cdkFocusInitial>
          <span aria-hidden="true">&times;</span>
        </button>
      </h2>
      <mat-divider style="padding-bottom: 1rem;"></mat-divider>
    </div>
    <mat-dialog-content>
      <p>{{ 'resend_contract.note' | translate }}</p>
      <div class="mat-table-container">
        <mat-table [dataSource]="dataSource" class="mat-table-col-extra-sm">
          <!-- check -->
          <ng-container matColumnDef="check">
            <mat-header-cell *matHeaderCellDef
              class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
              <mat-checkbox
                [(ngModel)]="checkAll" (change)="checkAllCheckBox()" color="primary"></mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let element"
              class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
              (click)="$event.stopPropagation()">
              <mat-checkbox color="primary" [(ngModel)]="element.checked"
                (change)="onSelect(element)">
              </mat-checkbox>
            </mat-cell>
          </ng-container>

          <!-- Khách hàng -->
          <ng-container matColumnDef="userName">
            <mat-header-cell *matHeaderCellDef
              class="mat-header-cell-center mat-cell-non-boder-right-bottom">
              {{'headertable.customer_name' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
              matTooltip="{{element.userName}}">
              <span class="fix-width">{{element.userName}}</span>
            </mat-cell>
          </ng-container>

          <!-- Trạng thái xử lý -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom" style="min-width: 20%;">
              {{'headertable.status_process' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" style="min-width: 20%;"
              class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center">
              <nz-tag *ngIf="element.status === enumCustomerProcessingStatus.NO_PROCESS" style="margin-right: 0px;">
                {{'resend_contract.status.no_process' | translate}}</nz-tag>
              <nz-tag *ngIf="element.status === enumCustomerProcessingStatus.PROCESSING || element.status == enumCustomerProcessingStatus.WAIT_SETUP_FLOW" [nzColor]="'blue'"
                style="margin-right: 0px;">{{'resend_contract.status.processing' | translate}}
              </nz-tag>
              <nz-tag *ngIf="element.status === enumCustomerProcessingStatus.REJECTED" [nzColor]="'red'"
                style="margin-right: 0px;">{{'resend_contract.status.rejected' | translate}}
              </nz-tag>
              <nz-tag *ngIf="element.status === enumCustomerProcessingStatus.SIGNED" [nzColor]="'green'"
                style="margin-right: 0px;">{{'resend_contract.status.signed' | translate}}</nz-tag>
              <nz-tag *ngIf="element.status === enumCustomerProcessingStatus.CANCELLED" [nzColor]="'red'"
                style="margin-right: 0px;">{{'resend_contract.status.cancelled' | translate}}</nz-tag>
            </mat-cell>
          </ng-container>

          <!-- Phương thức gửi -->
          <ng-container matColumnDef="method">
            <mat-header-cell *matHeaderCellDef 
              class="mat-header-cell-center">
              {{'headertable.method_sent_contract_link' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="number-cell-center"
              (click)="$event.stopPropagation()">
              <div style="display: flex; flex-direction: row; justify-content: start; min-width: 150px">
                <mat-checkbox color="primary" [(ngModel)]="element.isSendSms" [disabled]="!element.checked">
                  {{'resend_contract.method.sms' | translate}}
                </mat-checkbox>
                <mat-checkbox color="primary" [(ngModel)]="sendEmail" disabled style="margin-left: 30px" *ngIf="element.email">
                  {{'resend_contract.method.email' | translate}}
                </mat-checkbox>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">
          </mat-row>
        </mat-table>
      </div>

    </mat-dialog-content>
    <div class="w-100 mat-dialog-draggable-footer">
      <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button [disabled]="dataSelected.size === 0" (click)="onClickBtnConfirm()"
                type="button" color="primary">
          <mat-icon class="mr-0">save</mat-icon>
          {{'button.send'| translate}}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
  
  
  